export default {
    namespaced: true,
    state: {
        testConfig: [
            {
                id: '29ecf98d-90de-489b-8402-c9ac9b6cacba',
                name: 'General',
                tests: [
                    {
                        title: 'Fund credentials',
                        description: 'Understanding how well-established the fund is',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Length of track record',
                                suffix: 'years',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'AUM',
                                suffix: 'm',
                                visible: true,
                            },
                        ],
                        type: 'bubble',
                    },
                    {
                        title: 'Fees',
                        description: 'Considering the annual management charges levied by the manager',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Fee',
                                suffix: '%',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Return (% - pa over 1y)',
                                suffix: '%',
                                visible: true,
                            },
                        ],
                        type: 'bubble',
                    },
                    {
                        title: 'Research view',
                        description: 'Understanding LCP\'s research view of the fund',
                        filters: [
                            {
                                type: 'Category',
                                axis: 'None',
                                title: 'Rating',
                                suffix: null,
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Standard deviation (% pa)',
                                suffix: '%',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Return (% - pa over 1y)',
                                suffix: '%',
                                visible: false,
                            },
                        ],
                        legend: [
                            { title: 'Unrated', color: '#df3f6f' },
                            { title: 'Review', color: '#8da8ad' },
                            { title: 'Buy', color: '#00a3c7' },
                            { title: 'Hold', color: '#002f5f' },
                        ],
                        type: 'bubble',
                    },
                    {
                        title: 'Downside protection',
                        description: 'Considering the manager\'s track record of not losing money',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Max drawdown',
                                suffix: '%',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Return (% - pa over 1y)',
                                suffix: '%',
                                visible: true,
                            },
                        ],
                        type: 'bubble',
                    },
                    {
                        title: 'Performance',
                        description: 'Considering the fund\'s track record of delivering returns and the volatility of those returns',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Standard deviation (% pa)',
                                suffix: '%',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Return (% - pa over 1y)',
                                suffix: '%',
                                visible: true,
                            },
                        ],
                        type: 'bubble',
                    },
                ],
            },
            {
                name: 'Absolute Return',
                id: '30ecf98d-90de-489b-8402-c9ac9b6cacba',
                tests: [
                    {
                        title: 'Fund credentials',
                        description: 'How well-established the funds are',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Length of track record',
                                suffix: 'years',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'AUM',
                                suffix: 'm',
                                visible: true,
                            },
                        ],
                        type: 'bubble',
                    },
                    {
                        title: 'Complexity',
                        description: 'A measure of how complex the funds’ investment processes are',
                        filters: [
                            {
                                type: 'Category',
                                axis: 'x',
                                title: 'Complexity',
                                suffix: '',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Count',
                                suffix: '',
                                visible: false,
                            },
                        ],
                        type: 'column',
                    },
                    {
                        title: 'Betas to market indices',
                        description: 'The funds’ betas to market indices',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Beta to bonds',
                                suffix: '%',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Beta to equities',
                                suffix: '%',
                                visible: true,
                            },
                        ],
                        type: 'bubble',
                    },
                    {
                        title: 'Research view',
                        description: 'LCP\’s research view of the funds',
                        filters: [
                            {
                                type: 'Category',
                                axis: 'x',
                                title: 'LCP rating',
                                suffix: '',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Count',
                                suffix: '',
                                visible: false,
                            },
                        ],
                        type: 'column',
                    },
                    {
                        title: 'Fees',
                        description: 'How much the managers charge',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Fee',
                                suffix: '',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Count',
                                suffix: '',
                                visible: false,
                            },
                        ],
                        type: 'histogram',
                    },
                    {
                        title: 'Performance',
                        description: 'The funds\’ historic volatility and return characteristics',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Standard deviation (% pa)',
                                suffix: '%',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Return (% - pa over 1y)',
                                suffix: '%',
                                visible: true,
                            },
                        ],
                        type: 'bubble',
                    },
                    {
                        title: 'Downside protection',
                        description: 'A measure of how well the funds protect capital',
                        filters: [
                            {
                                type: 'Value',
                                axis: 'x',
                                title: 'Max drawdown',
                                suffix: '%',
                                visible: true,
                            },
                            {
                                type: 'Value',
                                axis: 'y',
                                title: 'Return (% - pa over 1y)',
                                suffix: '%',
                                visible: true,
                            },
                        ],
                        type: 'bubble',
                    },
                ],
            },
            // {
            //     id: 'a58b51b2-48bb-416a-bcfa-43c0536c1377',
            //     name: 'Infrastructure',
            //     tests: [
            //         {
            //             title: 'Fund credentials',
            //             description: 'Understanding how well-established the fund is',
            //             filters: [
            //                 {
            //                     type: 'Value',
            //                     axis: 'x',
            //                     title: 'Expected time to drawdown (months)',
            //                     suffix: '',
            //                     visible: true,
            //                 },
            //                 {
            //                     type: 'Value',
            //                     axis: 'y',
            //                     title: 'AUM',
            //                     suffix: '',
            //                     visible: true,
            //                 },
            //             ],
            //             type: 'bubble',
            //         }, {
            //             title: 'Yield and return',
            //             description: 'Understanding the how well-established the fund is',
            //             filters: [
            //                 {
            //                     type: 'Value',
            //                     axis: 'x',
            //                     title: 'Expected return (% pa)',
            //                     suffix: '',
            //                     visible: true,
            //                 },
            //                 {
            //                     type: 'Value',
            //                     axis: 'y',
            //                     title: 'Cash yield (% pa)',
            //                     suffix: '',
            //                     visible: true,
            //                 },
            //             ],
            //             type: 'bubble',
            //         }, {
            //             title: 'Solvency capital ratio (estimate)',
            //             description: 'Understanding the how well-established the fund is',
            //             filters: [
            //                 {
            //                     type: 'Value',
            //                     axis: 'y',
            //                     title: 'Solvency capital ratio (estimate)',
            //                     suffix: '',
            //                     visible: true,
            //                 },
            //                 {
            //                     type: 'Value',
            //                     axis: 'x',
            //                     title: 'Expected return (% pa)',
            //                     suffix: '',
            //                     visible: true,
            //                 },
            //             ],
            //             type: 'bubble',
            //         },
            //         {
            //             title: 'Research view',
            //             description: 'LCP\’s research view of the funds',
            //             filters: [
            //                 {
            //                     type: 'Category',
            //                     axis: 'x',
            //                     title: 'LCP rating',
            //                     suffix: '',
            //                     visible: true,
            //                 },
            //                 {
            //                     type: 'Value',
            //                     axis: 'y',
            //                     title: 'Count',
            //                     suffix: '',
            //                     visible: false,
            //                 },
            //             ],
            //             type: 'column',
            //         },
            //     ],
            // },
        ],
        pinnedFunds: [

        ],
    },
    getters: {
    },
    actions: {
    },
    mutations: {
        addPinnedFund (state, Ticker) {
            state.pinnedFunds.push(Ticker);
        },
        removePinnedFund (state, index) {
            state.pinnedFunds.splice(index, 1);
        },
        resetPinnedFunds (state) {
            state.pinnedFunds = [];
        },
    },
};
